<template>
  <div>
    <div class="btn-planning">
      <el-button class="default"
                   @click="openSummary"
                 :disabled="!validPlanning">
        ENVIAR VISITAS A SIMPLIROUTE
      </el-button>
    </div>
    <DialogSummary ref="summary"
                   @sendPlanning="sendPlanning"
                   @batchStarted="handleBatchStarted"
                   @batchCompleted="handleBatchCompleted"
                   @batchFailed="handleBatchFailed"
                   @batchCancelled="handleBatchCancelled"/>
  </div>
</template>

<script>
import DialogSummary from './Summary.vue';
import { apiRequest } from '../../../../backend/vue-axios/axios';
import { getRumDuration, startRumTiming, trackBusinessFlow } from '@/observability/datadogRum';

// Log inmediato para verificar que este archivo se carga
console.log('🔥 Send.vue SCRIPT LOADED - Deploy working!');

export default {
  props: {
    sectors: {
      type: Array,
      default() {
        return [];
      },
    },
    extraData: {
      type: Object,
      default() {
        return [];
      },
    },
    suborders: {
    type: Array,
    default() {
      return [];
    },
  },
    validPlanning: {
      type: Boolean,
      default() {
        return false;
      },
    },
    countSocWithoutSector: {
      type: Number,
      default() {
        return 0;
      },
    },
    historyCode: {
      type: String,
      default: '',
    },
  },
  name: 'PlanningSend',
  components: {
    DialogSummary,
  },
  data() {
    return {
    };
  },
  mounted() {
    console.log('🚀 Send.vue component mounted - logs working!');
    console.log('📅 Mounted at:', new Date().toISOString());
  },
  methods: {
    openSummary() {
  trackBusinessFlow({
    module: 'planning',
    flow: 'simpliroute_visits',
    action: 'summary_opened',
    status: 'success',
    context: {
      history_code: this.historyCode,
      suborders_count: this.suborders.length,
      count_without_sector: this.countSocWithoutSector,
    },
  });
  this.$refs.summary.showDialog(
    this.countSocWithoutSector,
    this.extraData,
    this.sectors,
    this.suborders // <-- Agregás esto
  );
  },
    sendPlanning() {
      // Marcar subórdenes filtradas antes de enviar
      this.markFilteredSuborders();
      const startedAt = startRumTiming();
      trackBusinessFlow({
        module: 'planning',
        flow: 'simpliroute_visits',
        action: 'send_requested',
        status: 'attempt',
        context: {
          history_code: this.historyCode,
          total_suborders: this.suborders.length,
          planned_suborders: this.planningData.suborders.length,
          filtered_suborders: this.suborders.length - this.planningData.suborders.length,
          facility: this.planningData.facility,
          send_vls: this.planningData.sendVLs,
          load_attributes: this.planningData.loadAttributes,
        },
      });
      
      apiRequest({
        module: 'toolkit',
        service: 'visitCreation',
        params: this.planningData,
      }).then((response) => {
        trackBusinessFlow({
          module: 'planning',
          flow: 'simpliroute_visits',
          action: 'send_completed',
          status: 'success',
          durationMs: getRumDuration(startedAt),
          context: {
            history_code: this.historyCode,
            batch_id: response.data.batchId,
            planned_suborders: this.planningData.suborders.length,
          },
        });
        // Emitir el batchId al componente Summary para iniciar el seguimiento del progreso
        this.$refs.summary.handleBatchStarted(response.data.batchId);
      }).catch(() => {
        trackBusinessFlow({
          module: 'planning',
          flow: 'simpliroute_visits',
          action: 'send_completed',
          status: 'error',
          durationMs: getRumDuration(startedAt),
          context: {
            history_code: this.historyCode,
            planned_suborders: this.planningData.suborders.length,
          },
        });
        this.$notify({
          type: 'error',
          title: 'Error',
          message: 'Problemas al enviar las visitas',
        });
        this.$refs.summary.closeDialog();
      });
    },
    handleBatchStarted(batchId) {
      // Este método se llama desde el componente Summary
      trackBusinessFlow({
        module: 'planning',
        flow: 'simpliroute_visits',
        action: 'batch_started',
        status: 'success',
        context: {
          history_code: this.historyCode,
          batch_id: batchId,
        },
      });
      this.$emit('batchStarted', batchId);
    },
    handleBatchCompleted(data) {
      // Re-emitir el evento al componente padre
      this.$emit('batchCompleted', data);
    },
    handleBatchFailed(data) {
      // Re-emitir el evento al componente padre
      this.$emit('batchFailed', data);
    },
    handleBatchCancelled() {
      // Re-emitir el evento al componente padre
      this.$emit('batchCancelled');
    },
    // Método para identificar y marcar subórdenes filtradas
    markFilteredSuborders() {
      const filteredSuborders = this.suborders.filter(s =>
        s.last_state_name === 'Cancelado' || s.last_state_name === 'Terminado' || s.last_state_name === 'En ruta'
      );
      
      console.log('Subórdenes filtradas encontradas:', filteredSuborders.length);
      console.log('Estados encontrados:', this.suborders.map(s => s.last_state_name));
      
      // Emitir evento para marcar subórdenes filtradas con observaciones
      if (filteredSuborders.length > 0) {
        trackBusinessFlow({
          module: 'planning',
          flow: 'simpliroute_visits',
          action: 'suborders_filtered',
          status: 'success',
          context: {
            history_code: this.historyCode,
            filtered_suborders: filteredSuborders.length,
          },
        });
        console.log('Emitiendo evento subordersFiltered con:', filteredSuborders);
        this.$emit('subordersFiltered', filteredSuborders);
      }
    },
  },
  computed: {
    planningData() {
    const filtered = this.suborders.filter(s =>
      s.last_state_name !== 'Cancelado' && s.last_state_name !== 'Terminado' && s.last_state_name !== 'En ruta'
    );
    
    return {
      plannedDate: this.extraData.time_init
        ? this.extraData.time_init.split('T')[0]
        : null,
      facility: this.extraData.ct && this.extraData.ct.id
        ? this.extraData.ct.id
        : null,
      isCTT: this.extraData.ct && typeof this.extraData.ct.is_ctt !== 'undefined'
        ? this.extraData.ct.is_ctt
        : false,
      sendVLs: this.extraData.send_vls === true,
      loadAttributes: this.extraData.load_attributes || {},
      suborders: filtered.map(s => {
        const sector = s.excelSector || s.sector;
        
        // Solo incluir sector si tiene valor válido
        if (sector) {
          return {
            suborder: s.suborder,
            sector: sector,
          };
        }
        
        // No incluir propiedad sector
        return {
          suborder: s.suborder,
        };
      }),
    };
  },
},
};
</script>

<style lang="scss" scoped>
  .btn-planning {
    text-align: right;
    margin: 30px 0 20px 0;
    .el-button { width: 250px; }
  }
</style>
